import React from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../../entrevista/components/EntrevistaViewer.css';
import { useCuestionarioTesisTorresViewer } from './hooks/useCuestionarioTesisTorresViewer';
import {
  CuestionarioTesisTorresHero,
  PatientProfileSection,
  DolorBaseSection,
  EscalasSection,
  CuestionarioViewerActions,
} from './viewer/CuestionarioTesisTorresViewerSections';

const CuestionarioTesisTorresViewer = ({ idCuestionario, paciente }) => {
  const navigate = useNavigate();
  const {
    patientInfo,
    fields,
    openGood,
    setOpenGood,
    handleExportPDF,
  } = useCuestionarioTesisTorresViewer({ idCuestionario, paciente });

  return (
    <Box className="entrevista-viewer" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box className="entrevista-viewer__shell" sx={{ maxWidth: 1080, width: '100%' }}>
        <Box id="pdf-content" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CuestionarioTesisTorresHero createdAt={patientInfo.createdAt} />
          <PatientProfileSection patientInfo={patientInfo} />
          <DolorBaseSection fields={fields} />
          <EscalasSection fields={fields} />
        </Box>

        <CuestionarioViewerActions
          onExportPDF={handleExportPDF}
          onEdit={() => navigate(`/editar-tesis/${paciente}/${idCuestionario}`)}
        />

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success" onClose={() => setOpenGood(false)}>
            ¡Cuestionario actualizado!
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default CuestionarioTesisTorresViewer;
